import { render, staticRenderFns } from "./SupplierEvaluationCertificates.vue?vue&type=template&id=21a79c3e&scoped=true&"
import script from "./SupplierEvaluationCertificates.vue?vue&type=script&lang=js&"
export * from "./SupplierEvaluationCertificates.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEvaluationCertificates.vue?vue&type=style&index=0&id=21a79c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a79c3e",
  null
  
)

export default component.exports